import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-product-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Order Data Table", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "SKU Data Table", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Start Date", -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "End Date", -1)
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Outbound Order Containers", -1)
const _hoisted_21 = {
  key: 0,
  class: "d-flex mb-10"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "fw-semibold me-10",
  style: {"flex":"1"}
}, "Width", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "fw-semibold me-10",
  style: {"flex":"1"}
}, "Depth", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "fw-semibold me-10",
  style: {"flex":"1"}
}, "Height", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "fw-semibold me-10",
  style: {"flex":"2"}
}, "Name", -1)
const _hoisted_26 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Filters", -1)
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
    type: "submit"
  }, " Submit ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("select", {
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.OrderDataTableName) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTables, (table) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: table.tableID,
                    value: table.tableID
                  }, _toDisplayString(table.name), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.OrderDataTableName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("select", {
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.SKUDataTableName) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skuTables, (table) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: table.tableID,
                    value: table.tableID
                  }, _toDisplayString(table.name), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.SKUDataTableName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.StartDate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.StartDate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-control shadow-none rounded-0 text-black",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.EndDate) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.EndDate]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              (_ctx.form.OutboundOrderContainers.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_26))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.OutboundOrderContainers, (container, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex mb-10"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((container.Width) = $event),
                    placeholder: "Width",
                    class: "form-control mr-10",
                    style: {"flex":"1"}
                  }, null, 8, _hoisted_27), [
                    [
                      _vModelText,
                      container.Width,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((container.Depth) = $event),
                    placeholder: "Depth",
                    class: "form-control mr-10",
                    style: {"flex":"1"}
                  }, null, 8, _hoisted_28), [
                    [
                      _vModelText,
                      container.Depth,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": ($event: any) => ((container.Height) = $event),
                    placeholder: "Height",
                    class: "form-control mr-10",
                    style: {"flex":"1"}
                  }, null, 8, _hoisted_29), [
                    [
                      _vModelText,
                      container.Height,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((container.Name) = $event),
                    placeholder: "Name",
                    class: "form-control mr-10",
                    style: {"flex":"2"}
                  }, null, 8, _hoisted_30), [
                    [_vModelText, container.Name]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeContainer(index)),
                    type: "button",
                    class: "btn btn-danger"
                  }, "Remove", 8, _hoisted_31)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addContainer && _ctx.addContainer(...args))),
                type: "button",
                class: "btn btn-primary mt-10"
              }, "Add Container"),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addStandardContainers && _ctx.addStandardContainers(...args))),
                type: "button",
                class: "btn btn-secondary mt-10"
              }, "Add Standard")
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Filters, (filter, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex mb-10"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((filter.Key) = $event),
                    placeholder: "Key",
                    class: "form-control mr-10"
                  }, null, 8, _hoisted_35), [
                    [_vModelText, filter.Key]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((filter.Value) = $event),
                    placeholder: "Value",
                    class: "form-control mr-10"
                  }, null, 8, _hoisted_36), [
                    [_vModelText, filter.Value]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeFilter(index)),
                    type: "button",
                    class: "btn btn-danger"
                  }, "Remove", 8, _hoisted_37)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addFilter && _ctx.addFilter(...args))),
                type: "button",
                class: "btn btn-primary mt-10"
              }, "Add Filter")
            ])
          ]),
          _hoisted_38
        ])
      ], 32)
    ])
  ]))
}